import { ChangeDetectionStrategy, Component, ContentChild, input, InputSignal, output, OutputEmitterRef, TemplateRef, ViewEncapsulation } from '@angular/core';
import { SplitterModule, SplitterResizeEndEvent, SplitterResizeStartEvent } from 'primeng/splitter';
import { SplitterConfig } from './_config/splitter.model';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'plyca-ui-splitter',
  templateUrl: './splitter.component.html',
  styleUrl: './splitter.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SplitterModule, NgTemplateOutlet]
})
export class PlycaUiSplitterComponent {
  @ContentChild(TemplateRef, { static: true }) panelTemplate!: TemplateRef<any>;

  public config: InputSignal<SplitterConfig> = input.required<SplitterConfig>();
  public activeIndexChange: OutputEmitterRef<number> = output<number>();
  public startResizeChange: OutputEmitterRef<number[]> = output<number[]>();
  public endResizeChange: OutputEmitterRef<number[]> = output<number[]>();

  public onPanelChange(event): void {
    this.activeIndexChange.emit(event.index);
  }

  public startResize(event: SplitterResizeStartEvent): void {
    this.startResizeChange.emit(event.sizes);
  }

  public endResize(event: SplitterResizeEndEvent): void {
    this.endResizeChange.emit(event.sizes);
  }
}
